import React from 'react';
import { connect } from 'react-redux';
import '../../styles/play_styles.scss';
import '../../styles/promotion.scss';
import Navbar from './play_Navbar';
import Footer from './play_Footer';
import config from '../../configuration.json';
class PolicyCookies extends React.Component {

    state = {
        scale: false
    };

    componentDidMount() {
    }


    render() {
        
        return (
 
<div>
      {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />

<div id="cookiespolicyContainer" className="text-justify">
    <h1>POLÍTICA DE COOKIES</h1>
    <p>
        Al igual que otros sitios web, tpz_pepsi.com (el “Sitio Web”) utiliza una tecnología denominada cookies
        para recabar información acerca de su uso por parte de los usuarios. El responsable del tratamiento de esa
        información es BHUB MARKETING Y ALIANZAS, S.L., con dirección en Calle Tamayo y Baus, 7, 1º, 28004 Madrid.
    </p>
    <p>
        Te informamos de que podemos utilizarlas en tu equipo a condición de que hayas dado tu consentimiento, salvo en
        los supuestos en los que sean necesarias para la navegación por el Sitio Web.
    </p>
    <p>
        A tal efecto, te indicamos que la utilización de las diferentes cookies por nuestro Sitio Web nos permite
        facilitar la navegación a través del Sitio Web y proporcionarte una mejor experiencia de usuario.
    </p>
    <h2>Definición</h2>
    <p>
        Una cookie es un archivo que se descarga en tu equipo terminal con la finalidad de almacenar datos que podrán
        ser actualizados y recuperados por la entidad responsable de su instalación. Salvo que hayas configurado tu
        navegador para deshabilitarlas, nuestro sistema las usará en tanto en cuanto visites nuestro Sitio Web y hayas
        aceptado su instalación.
    </p>
    <h2>Tratamiento de datos a partir de cookies</h2>
    <p>
        Si aceptas la instalación de cookies (en este momento no hacemos uso de ninguna cookie no
        obligatoria en el Sitio Web), trataremos tus datos según lo indicado a continuación:
    </p>
    <ul>
        <li>
            <strong>Finalidad del tratamiento:</strong> Mostrarte correctamente el contenido del sitio Web y permitir la
            navegación por las zonas del Sitio Web que requieren autenticación y, en definitiva, facilitarte la mejor
            experiencia de usuario posible.
        </li>
        <li>
            <strong>Base legal del tratamiento:</strong> Tu consentimiento expreso facilitado a través de los botones
            habilitados al efecto en el banner de cookies o en esta política.
        </li>
        <li>
            <strong>Destinatarios de tus datos:</strong> Únicamente tendrán acceso a tus datos personales algunos de
            nuestros prestadores de servicios que nos permitan recoger la información de navegación. Para ejecutar el
            servicio que nos prestan, estos
            proveedores tienen que acceder a los datos de nuestros clientes (por ejemplo, tiempo de navegación, páginas
            visitadas o recurrencia de las visitas). Estos prestadores de servicios tratarán tus datos según nuestras
            instrucciones y siempre bajo nuestro mando.
        </li>
        <li>
            <strong>Período de conservación de tus datos:</strong> Se indican los períodos de caducidad de cada cookie
            en la sección "Tipos de cookies utilizadas en la web", dentro de la columna "Caducidad".
        </li>
    </ul>
  
        <h2>Tipo de cookies utilizadas por el Sitio Web</h2>
    <p>
        En el Sitio Web utilizamos distintas categorías de cookies, que pueden clasificarse según su finalidad en
        las siguientes:
    </p>
    <ul>
        <li><strong>Obligatorias</strong></li>
    </ul>
    <p>
        Cookies estrictamente necesarias para navegar por la web, que permiten funciones básicas como la navegación de
        una sección a otra. Se encargan de aspectos técnicos como identificar perfiles o sesiones y gestionar
        preferencias de herramientas en el uso, interacción y localización del acceso a los contenidos. Las cookies
        obligatorias utilizadas por el Sitio Web son las siguientes:
    </p>
    <table className="cookies-table">
        <thead>
            <tr>
                <th>Nombre</th>
                <th>Finalidad</th>
                <th>Proveedor</th>
                <th>Caducidad</th>
            </tr>
        </thead>
        <tbody>

            <tr>
                <td>
                    cookieconsent_status
                </td>
                <td>
                    Guarda la configuración de aceptación del banner de información de cookies.
                </td>
                <td>
                    Propia
                </td>
                <td>
                    1 año
                </td>
            </tr>
            <tr>
                <td>
                    .AspNetCore.Antiforgery.XXXXXXXXXXX
                </td>
                <td>
                    Token de seguridad para evitar ataques de falsificación de solicitud entre sitios web.
                    XXXXXXXXXXX es una cadena de texto variable generada aleatoriamente.
                </td>
                <td>
                    Propia
                </td>
                <td>
                    2 días
                </td>
            </tr>
        </tbody>
    </table>
    <ul>
        <li><strong>Estadísticas</strong></li>
    </ul>
    <p>
        Estas cookies recogen información relativa al uso del Sitio Web, como la permanencia en el mismo y los
        contenidos visitados, para comprender cómo interactúan los usuarios con el Sitio Web y así mejorar aspectos de
        la navegación. <strong>No se usan cookies de este tipo en el Sitio Web.</strong>
    </p>
    <ul>
        <li><strong>Personalización de publicidad</strong></li>
    </ul>
    <p>
        Estas cookies obtienen información de la navegación del usuario para gestionar espacios publicitarios,
        ofreciendo anuncios relevantes según los gustos del usuario. <strong>No se usan cookies de este tipo en el Sitio Web.</strong>
    </p>
    <h2>Deshabilitar cookies</h2>
    <p>
        La práctica mayoría de los navegadores permiten advertir de la presencia de cookies o rechazarlas
        automáticamente. Si las rechazas podrás seguir usando nuestro Sitio Web pero posiblemente experimentes
        dificultades en cuanto a la navegabilidad y operatividad del Sitio Web y no puedas acceder a determinadas
        funcionalidades. Así, la desactivación puede provocar que el uso de algunos de los servicios del Sitio Web sea
        limitado y por tanto tu experiencia sea menos satisfactoria.
    </p>
    <h2>Retirar el consentimiento</h2>
    <p>
        Si quisieses retirar en cualquier momento tu consentimiento relacionado con la Política de Cookies, puedes
        eliminar las cookies almacenadas en tu equipo a través de los ajustes y configuraciones de tu
        navegador de Internet.
    </p>
    <p>
        Puedes ampliar la información sobre cómo deshabilitar las cookies, dependiendo de tu navegador, en los
        siguientes enlaces:
    </p>
    <ul>
        <li>
            <strong>Internet Explorer:</strong>
            <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">
                https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies
            </a>
        </li>
        <li>
            <strong>Firefox:</strong>
            <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">
                https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias
            </a>
        </li>
        <li>
            <strong>Chrome:</strong>
            <a href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es">
                https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=es
            </a>
        </li>
        <li>
            <strong>Safari:</strong> para iOS:
            <a href="https://support.apple.com/es-es/HT201265 ">
                https://support.apple.com/es-es/HT201265
            </a>
        </li>
    </ul>
    <h2>Modificaciones en esta política</h2>
    <p>
        Es posible que actualicemos la Política de Cookies de nuestro Sitio Web de cuando en cuando. Por ello, te
        recomendamos revisar esta política cada vez que accedas a nuestro Sitio Web con el objetivo de estar
        adecuadamente informado sobre cómo y para qué las utilizamos.
    </p>
    <h2>Contacto</h2>
    <p>
        Si tuvieras cualquier duda relacionada con la instalación de cookies por nuestra parte, por favor, escribe un
        email a <a href="mailto:dpo@bhub.es">dpo@bhub.es</a> y te responderemos tan pronto como sea posible.
    </p>

    <br />
    <br />
    <h1>AVISO LEGAL Y CONDICIONES GENERALES DE USO DEL SITIO WEB</h1>
    <h1>https://www.tpz_pepsi.com</h1>
    <h1>I. INFORMACIÓN GENERAL</h1>
    <p>
        En cumplimiento con el deber de información dispuesto en la Ley 34/2002 de Servicios de la Sociedad de la
        Información y el Comercio Electrónico (LSSI-CE) de 11 de julio, se facilitan a continuación los siguientes
        datos de información general de este sitio web:
    </p>
    <p>
        La titularidad de este sitio web, https://www.tpz_pepsi.com (en adelante, Sitio Web) la ostenta: 
        BHUB MARKETING Y ALIANZAS, S.L., provista de NIF: B86546017 e inscrita en el Registro Mercantil de Madrid 
        con los siguientes datos registrales: Tomo 30143, Folio 188, Hoja M 542558, y cuyos datos de contacto son:
    </p>
    <p>
        Dirección: Madrid, Calle Tamayo y Baus, 7, 1º, código postal 28004<br />
        Teléfono de contacto: 915289983<br />
        Email de contacto: dpo@bhub.es
    </p>

    <h1>II. TÉRMINOS Y CONDICIONES GENERALES DE USO</h1>

    <h2>El objeto de las condiciones: El Sitio Web</h2>

    <p>
        El objeto de las presentes Condiciones Generales de Uso (en adelante, Condiciones) es regular el acceso y 
        la utilización del Sitio Web.
    </p>
    <p>
        B!Hub se reserva la facultad de modificar, en cualquier momento, y sin aviso previo, la presentación y
        configuración del Sitio Web y de los Contenidos y Servicios que en él pudieran estar incorporados. El
        Usuario reconoce y acepta que en cualquier momento B!Hub pueda interrumpir, desactivar y/o cancelar 
        cualquiera de estos elementos que se integran en el Sitio Web o el acceso a los mismos.
    </p>
    <p>
        El acceso al Sitio Web por el Usuario tiene carácter libre y, por regla general, es gratuito sin que el 
        Usuario tenga que proporcionar una contraprestación para poder disfrutar de ello, salvo en lo relativo 
        al coste de conexión a través de la red de telecomunicaciones suministrada por el proveedor de acceso 
        que hubiere contratado el Usuario.
    </p>
    <p>
        El Titular ser reserva el derecho a denegar o retirar el acceso al portal y/o los servicios ofrecidos 
        sin necesidad de advertencia previa, a instancia propia o de un tercero, a aquellos usuarios que incumplan 
        el contenido de este aviso legal.
    </p>

    <h2>El Usuario</h2>

    <p>
        El acceso, la navegación y uso del Sitio Web confiere la condición de Usuario, por lo que se aceptan, 
        desde que se inicia la navegación por el Sitio Web, todas las Condiciones aquí establecidas, así como 
        sus ulteriores modificaciones, sin perjuicio de la aplicación de la correspondiente normativa legal de 
        obligado cumplimiento según el caso.
    </p>
    <p>
        El Usuario asume su responsabilidad para realizar un uso correcto del Sitio Web. Esta responsabilidad 
        se extenderá a:
    </p>
    <ul>
        <li>
            Un uso de la información, Contenidos y/o Servicios y datos ofrecidos por B!Hub sin que sea 
            contrario a lo dispuesto por las presentes Condiciones, la Ley, la moral o el orden público, o 
            que de cualquier otro modo puedan suponer lesión de los derechos de terceros o del mismo funcionamiento 
            del Sitio Web.
        </li>
        <li>
            La veracidad y licitud de las informaciones aportadas por el Usuario en los formularios extendidos 
            por B!Hub para el acceso a ciertos Contenidos o Servicios ofrecidos por el Sitio Web. En todo caso, 
            el Usuario notificará de forma inmediata a B!Hub acerca de cualquier hecho que permita el uso 
            indebido de la información registrada en dichos formularios, tales como, pero no sólo, el robo, 
            extravío, o el acceso no autorizado a identificadores y/o contraseñas, con el fin de proceder a su 
            inmediata cancelación.
        </li>
    </ul>
    <p>
        El mero acceso a este Sitio Web no supone entablar ningún tipo de relación de carácter comercial entre 
        B!Hub y el Usuario.
    </p>
    <p>
        El Usuario declara ser mayor de edad y disponer de la capacidad jurídica suficiente para vincularse por 
        las presentes Condiciones. Por lo tanto, este Sitio Web de B!Hub no se dirige a menores de edad. B!Hub 
        declina cualquier responsabilidad por el incumplimiento de este requisito.
    </p>
    <p>
        El Sitio Web está dirigido principalmente a Usuarios residentes en España.
    </p>
    <p>
        Es responsabilidad del Usuario, acceder a las condiciones legales insertas en la presente web y leerlas 
        detenidamente, así como, las políticas de privacidad y cookies.
    </p>

    <h1>III. ACCESO Y NAVEGACIÓN EN EL SITIO WEB: EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD</h1>

    <p>
        B!Hub no garantiza la continuidad, disponibilidad y utilidad del Sitio Web, ni de los Contenidos o 
        Servicios. B!Hub hará todo lo posible por el buen funcionamiento del Sitio Web, sin embargo, no se 
        responsabiliza ni garantiza que el acceso a este Sitio Web no vaya a ser ininterrumpido o que esté 
        libre de error.
    </p>
    <p>
        Tampoco se responsabiliza o garantiza que el contenido o software al que pueda accederse a través 
        de este Sitio Web, esté libre de error o cause un daño al sistema informático (software y hardware) 
        del Usuario. En ningún caso B!Hub será responsable por las pérdidas, daños o perjuicios de cualquier 
        tipo que surjan por el acceso, navegación y el uso del Sitio Web, incluyéndose, pero no limitándose, 
        a los ocasionados a los sistemas informáticos o los provocados por la introducción de virus.
    </p>
    <p>
        B!Hub tampoco se hace responsable de los daños que pudiesen ocasionarse a los usuarios por un uso 
        inadecuado de este Sitio Web. En particular, no se hace responsable en modo alguno de las caídas, 
        interrupciones, falta o defecto de las telecomunicaciones que pudieran ocurrir.
    </p>

    <h1>IV. POLÍTICA DE ENLACES</h1>

    <p>
        Se informa que el Sitio Web de B!Hub pone o puede poner a disposición de los Usuarios medios de enlace 
        (como, entre otros, links, banners, botones), directorios y motores de búsqueda que permiten a los 
        Usuarios acceder a sitios web pertenecientes y/o gestionados por terceros.
    </p>
    <p>
        La instalación de estos enlaces, directorios y motores de búsqueda en el Sitio Web tiene por objeto 
        facilitar a los Usuarios la búsqueda de y acceso a la información disponible en Internet, sin que 
        pueda considerarse una sugerencia, recomendación o invitación para la visita de los mismos.
    </p>
    <p>
        B!Hub no ofrece ni comercializa por sí ni por medio de terceros los productos y/o servicios disponibles 
        en dichos sitios enlazados.
    </p>
    <p>
        Asimismo, tampoco garantizará la disponibilidad técnica, exactitud, veracidad, validez o legalidad de 
        sitios ajenos a su propiedad a los que se pueda acceder por medio de los enlaces.
    </p>
    <p>
        B!Hub no asume ninguna responsabilidad por los daños y perjuicios que pudieran producirse por el 
        acceso, uso, calidad o licitud de los contenidos, comunicaciones, opiniones, productos y servicios 
        de los sitios web no gestionados por B!Hub y que sean enlazados en este Sitio Web.
    </p>
    <h1>V. PROPIEDAD INTELECTUAL E INDUSTRIAL</h1>
    <p>
        B!Hub, por sí o como parte cesionaria, es titular de todos los derechos de propiedad intelectual e 
        industrial del Sitio Web, así como de los elementos contenidos en el mismo (a título enunciativo y 
        no exhaustivo, imágenes, sonido, audio, vídeo, software o textos, marcas o logotipos, combinaciones 
        de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios 
        para su funcionamiento, acceso y uso, etc.). Serán, por consiguiente, obras protegidas como propiedad 
        intelectual por el ordenamiento jurídico español, siéndoles aplicables tanto la normativa española y 
        comunitaria en este campo, como los tratados internacionales relativos a la materia y suscritos por 
        España.
    </p>
    <p>
        Todos los derechos reservados. En virtud de lo dispuesto en la Ley de Propiedad Intelectual, quedan 
        expresamente prohibidas la reproducción, la distribución y la comunicación pública, incluida su 
        modalidad de puesta a disposición, de la totalidad o parte de los contenidos de esta página web, 
        con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización de 
        B!Hub.
    </p>
    <p>
        El Usuario se compromete a respetar los derechos de propiedad intelectual e industrial de B!Hub. 
        Podrá visualizar los elementos del Sitio Web o incluso imprimirlos, copiarlos y almacenarlos en 
        el disco duro de su ordenador o en cualquier otro soporte físico siempre y cuando sea, exclusivamente, 
        para su uso personal. El Usuario, sin embargo, no podrá suprimir, alterar, o manipular cualquier 
        dispositivo de protección o sistema de seguridad que estuviera instalado en el Sitio Web.
    </p>
    <h1>VI. MODIFICACIÓN DE ESTE AVISO LEGAL, LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h1>
    <p>
        B!Hub se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas 
        en su portal.
    </p>
    <p>
        B!Hub se reserva la facultad de presentar las acciones civiles o penales que considere necesarias 
        por la utilización indebida del Sitio Web y Contenidos, o por el incumplimiento de las presentes 
        Condiciones.
    </p>
    <p>
        La relación entre el Usuario y B!Hub se regirá por la normativa vigente y de aplicación en el 
        territorio español. De surgir cualquier controversia en relación a la interpretación y/o a la 
        aplicación de estas Condiciones las partes someterán sus conflictos a la jurisdicción ordinaria 
        sometiéndose a los jueces y tribunales que correspondan conforme a derecho.
    </p>
    <h1>VIII. MEDIDAS DE SEGURIDAD – SSL</h1>
    <p>
        B!Hub ha contratado para su sitio web un certificado SSL («Secure Sockets Layer»).
    </p>
    <p>
        Un certificado SSL permite proteger toda la información personal y confidencial que se pueda 
        manejar en un sitio web, independientemente de la información que se esté transmitiendo, como 
        por ejemplo, desde cualquiera de los formularios de contacto del sitio web hasta el servidor, 
        o los datos introducidos para la suscripción de boletines de noticias o accesos a las áreas 
        protegidas, etc.
    </p>
    <p>
        La dirección del sitio web aparecerá en color verde, activándose el protocolo “https” que 
        permite conexiones seguras desde un servidor web al navegador del usuario.
    </p>
    <br/>
    <br/>
    <p>Última modificación: 8 de noviembre de 2021</p>
</div>
   <Footer footerName="thank-you-footer" />
</div>
        );
    }
 }

const mapStateToProps = state => {
    return {

    };
};

export default connect(mapStateToProps, {})(PolicyCookies);


